export const renderReceiptTitle = (status) => {
  switch (status) {
    case "DONE":
      return "bank.operation-success";

    case "FAILED":
      return "bank.operation-failed";

    case "TROUBLESHOOTING":
      return "bank.operation-troubleshooting";

    default:
      break;
  }
};

export const renderReceiptText = (status) => {
  switch (status) {
    case "DONE":
      return "text-primary-0";

    case "FAILED":
    case "TROUBLESHOOTING":
      return "text-error-0";

    default:
      break;
  }
};

export const paymentMethodType = ({ transaction_type, t }) => {
  switch (`${transaction_type}`.toLowerCase()) {
    case "card":
      return t("bank.card-to-card-with-pol");

    case "pol":
      return `${t("bank.between-bank")}|${t("bank.pol")}`;

    case "paya":
      return `${t("bank.between-bank")}|${t("bank.paya")}`;

    case "satna":
      return `${t("bank.between-bank")}|${t("bank.satna")}`;

    case "internal":
      return `${t("bank.internal")}`;

    default:
      return "";
  }
};
